import * as actionTypes from "../../actions/actionTypes";

export const initialState = {
  noService: true,
  lowPriority: true,
  mediumPriority: true,
  highPriority: true,
  noVariant: true,
  resVariant: true,
  comVariant: true,
  technologiesVariant: true,
  other: "ALL",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.filter.SET:
      return { ...action.filter };
    case actionTypes.filter.SET_MEDIUM_PRIORITY_ONLY:
      return {
        ...initialState,
        noService: false,
        lowPriority: false,
        highPriority: false,
      };
    default:
      return state;
  }
};

export default reducer;
